// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts'
export let DirectNonFixedInstumentListResponseMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_INSTRUMENT_LIST_RESPONSE)
    this.NonFixedInstrumentInfoList = []
}

export let NonFixedInstrumentInfo = function ()
{
    this.InstrDateSettingsList = null
    this.ID = null
    this.Name = null
    this.InstrType = 0
    this.GroupId = 0
    this.ExchangeId = 0
    this.Underlier = null
    this.UnderlierUnderlier = null
    this.PointSize = 0
    this.UseOptionDescription = null
    this.AllExpDateLoaded = true;
    this.AllContractsLoaded = true;
    this.SerieName = null;
    this.UnderlierID = null;
    this.Description = null;
    this.Routes = null;
    this.TradingExchange = null;
    this.MarketDataExchange = null;
    this.CountryId = -1;
    this.UnderlierDescr = null;
    this.UnderlierCountryId = null;
    this.UnderlierTradingExchange = null;
}

NonFixedInstrumentInfo.prototype.toString = function ()
{
    return this.Name || 'null'
}